var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-sessions-list',{attrs:{"sessions":_vm.allSessions,"is-loading":_vm.isLoading,"has-error":_vm.hasError,"error-message":_vm.$options.i18n.errorMessage,"show-empty-state":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }